export enum TimerAction {
  INIT_TIMER = 'init_timer',
  START_TIMER = 'start_timer',
  STOP_TIMER = 'stop_timer',
  RESET_TIMER = 'reset_timer',
}
